export default () => ({
  standardOpeningHours: '',
  holidayOpeningHours: '',
  tenantDetails: '',
  selectedTenant: null,
  totalLogEntries: 0,
  outOfHoursAuditLog: [],
  sortDir: '',
  orderBy: '',
  pageSize: 10
})



// WEBPACK FOOTER //
// ./src/store/modules/openinghours/state.js